export default {
  title: "Pay-Per-Use",
  subtitle: "Purchase credits as needed, no subscription required",
  calculation_title: "Carbon Emission Calculations",
  report_title: "Reports",
  combo_title: "Combination Packages",
  combo_subtitle: "Save more with our combination packages",
  select_quantity: "Select quantity",
  select_package: "Select a package",
  total: "Total",
  calculation_credits: "Calculation credits",
  report_credits: "Report credits",
  credits: "credits",
  price: "Price",
  buy_now: "Buy Now",
  starter_pack: "Starter Pack",
  professional_pack: "Professional Pack",
  enterprise_pack: "Enterprise Pack",
  save_x_percent: "Save {percent}%",
  note: "Credits you purchase never expire.",
  expiry_note:
    "You can use them anytime. In the future, optional credit extension or conversion features will be available.",
  calculation_price: "Carbon Emission Calculations",
  report_price: "Reports",
  calculation_price_dynamic: "{price} per calculation",
  report_price_dynamic: "{price} per report",
  benefits: "Pay-Per-Use Benefits",
  future_features: "Upcoming Features",
  future_features_desc:
    "We plan to introduce optional credit extensions and exchanges later. No action is required now.",
  extension_option_future: "Credit Extension",
  extension_option_future_desc:
    "Extend your credits' validity for a small fee (available in a future release).",
  credit_exchange_future: "Credit Exchange",
  credit_exchange_future_desc:
    "Exchange unused or expired credits for trial access in future versions.",
  quantity: "Quantity",
  ladder_pricing: "Ladder pricing",
  unit: "unit",
  pay_per_use_benefit1: "No subscription required",
  pay_per_use_benefit2: "Pay only for what you use",
  pay_per_use_benefit3: "Forever valid",
};
